export default __webpack_public_path__ + "static/media/sign-in-welcome-6.bcc50096.jpg";